module.exports = __webpack_public_path__ + "static/home-search-form-front-3-033f7e975d3b91b13cd67f79becc32f1.png";